/**
 * @description 登入 身份驗證頁 格式化顯示的認證方式用
*/
export enum LoginAuthenticateType {
  /** 手機 */
  Mobile = 'Mobile',
  /**  Email */
  EmailAddr = 'EMAIL_ADDR'
}
